import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana58Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1466_28456)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("1"))}
        d="M401.358 435.54L381.509 495.087L280.059 466.416L315.346 422.307C322.403 413.486 335.93 415.691 341.811 417.896L401.358 435.54Z"
        fill={getFillByLot(1, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("10"))}
        d="M244.764 506.114L280.051 466.416L348.423 486.265L326.368 552.428C305.783 547.282 261.525 535.667 249.174 530.374C236.824 525.081 241.088 511.995 244.764 506.114Z"
        fill={getFillByLot(10, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("9"))}
        d="M410.18 574.483L326.373 552.429L348.427 486.266L427.823 510.526L410.18 574.483Z"
        fill={getFillByLot(9, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("2"))}
        d="M491.784 459.8L401.361 435.54L381.512 495.087L474.14 523.758L491.784 459.8Z"
        fill={getFillByLot(2, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("8"))}
        d="M493.99 598.741L410.184 574.481L427.827 510.523L513.839 534.783L493.99 598.741Z"
        fill={getFillByLot(8, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("7"))}
        d="M577.805 620.793L493.998 598.738L513.847 534.78L599.859 556.835L577.805 620.793Z"
        fill={getFillByLot(7, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("6"))}
        d="M624.103 634.03L577.789 620.798L599.844 556.84L718.937 594.332L624.103 634.03Z"
        fill={getFillByLot(6, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("5"))}
        d="M776.272 567.865L718.931 594.33L654.973 574.481L674.822 510.523L769.656 536.989C789.064 547.575 782.153 561.984 776.272 567.865Z"
        fill={getFillByLot(5, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("4"))}
        d="M582.2 484.06L674.829 510.525L654.98 574.483L564.557 548.017L582.2 484.06Z"
        fill={getFillByLot(4, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("3"))}
        d="M491.778 459.798L582.202 484.058L564.558 548.016L474.135 523.756L491.778 459.798Z"
        fill={getFillByLot(3, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1466_28456"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1466_28456"
            transform="matrix(0.00302513 0 0 0.00401052 -4.50846 -2.82779)"
          />
        </pattern>
        <image
          id="image0_1466_28456"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
